import { SxProps } from '@mui/material';
import { DetailViewContentContainerSx } from '../../styles';
import theme from 'themes/theme';

export const BillingAndEnrollmentSx: SxProps = {
  ...DetailViewContentContainerSx,
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  marginBottom: '32px',
  overflowY: 'auto',
};

export const FieldTypographySx: SxProps = {
  maxWidth: '500px',
  whiteSpace: 'break-spaces',
};

export const HeaderTypographySx: SxProps = {
  color: theme?.palette?.colors?.gray60,
  fontSize: '12px',
  fontWeight: '500',
  lineHeight: '166%',
  letterSpacing: '1px',
};
